import * as actionTypes from "./actionTypes";
import { DEFAULT_PAGE_SIZE, PAYMENT_SOURCE } from "./constants";

const initialState = {
  loading: false,
  rows: [],
  columns: [],
  totalCount: 0,
  source: PAYMENT_SOURCE.B2B,
  searchText: "",
  statuses: [],
  pagination: { pageSize: DEFAULT_PAGE_SIZE, currentPage: 1 }
};

const normalizeList = (data) => {
  if (!data) return { rows: [], columns: [], totalCount: 0 };
  if (Array.isArray(data)) return { rows: data, columns: [], totalCount: data.length };

  const rows =
    (Array.isArray(data.dataSource) && data.dataSource) ||
    (Array.isArray(data.rows) && data.rows) ||
    (Array.isArray(data.items) && data.items) ||
    (Array.isArray(data.content) && data.content) ||
    (Array.isArray(data.data) && data.data) ||
    (Array.isArray(data.results) && data.results) ||
    (Array.isArray(data.response) && data.response) ||
    [];

  const columns = Array.isArray(data.columns) ? data.columns : [];

  const totalCount =
    data.totalCount ?? data.totalCars ?? data.totalElements ?? data.total ?? data.totalRecords ?? rows.length;

  return { rows, columns, totalCount };
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PAYMENTS_START:
      return { ...state, loading: true };

    case actionTypes.FETCH_PAYMENTS_SUCCESS: {
      const { rows, columns, totalCount } = normalizeList(action.data);
      return { ...state, loading: false, rows, columns, totalCount };
    }

    case actionTypes.FETCH_PAYMENTS_FAIL:
      return { ...state, loading: false };

    case actionTypes.SET_PAYMENTS_SOURCE:
      return {
        ...state,
        source: action.source,
        pagination: { ...state.pagination, currentPage: 1 }
      };

    case actionTypes.SET_PAYMENTS_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.text,
        pagination: { ...state.pagination, currentPage: 1 }
      };

    case actionTypes.SET_PAYMENTS_STATUSES:
      return {
        ...state,
        statuses: action.statuses || [],
        pagination: { ...state.pagination, currentPage: 1 }
      };

    case actionTypes.SET_PAYMENTS_CURRENT_PAGE:
      return {
        ...state,
        pagination: { ...state.pagination, currentPage: action.page }
      };

    case actionTypes.SET_PAYMENTS_PAGE_SIZE:
      return {
        ...state,
        pagination: { pageSize: action.size, currentPage: 1 }
      };

    case actionTypes.RESET_PAYMENTS:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
